module.exports = __webpack_public_path__ + "static/media/taxation_law_icon_orange.7676244e.svg";